import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'RoleProductMenu'
}
const methods = [
    'InsertRoleProductMenus',
    'FindByConditions',
    'FindRoleMenuIds'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const RoleProductMenuApi = ZJApi.defineNewApi('RoleProductMenuApi', factory)

export default RoleProductMenuApi